import React, { useEffect, useState } from "react";
import { Card, Input, Button } from "antd";
import { MailOutlined, SendOutlined } from "@ant-design/icons";
import { toast } from 'react-toastify';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Forgot = () => {

    const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const navigate = useNavigate();

    const handleSendOtp = async () => {
        if (!email) {
            toast.error("Email is required");
            return;
        }
        if (!validateEmail(email)) {
            toast.error("Invalid email format");
            return;
        }

        setIsSubmitting(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}api/forgot-password`,
                {
                    email
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            if (res.data.status === true) {
                secureLocalStorage.setItem('forgot_email', JSON.stringify(email))
                toast.success(res?.data?.message);
                setTimeout(function () {
                    navigate('/otp-verification');
                }, 1000)
            } else {
                toast.error(res?.data?.message || "Failed to send OTP");
            }
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || "Something went wrong");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <Card className="w-full max-w-md shadow-xl rounded-2xl p-6">
                <h1 className="text-2xl font-bold text-brandBlue mb-2 font-syne">
                    Forgot Password
                </h1>
                <p className="text-gray-600 mb-6 font-outfit">
                    Enter your email address to receive an OTP for resetting your password.
                </p>

                <Input
                    type="email"
                    size="large"
                    placeholder="Enter your email"
                    prefix={<MailOutlined className="text-gray-400" />}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="rounded-full font-outfit"
                />

                <Button
                    type="primary"
                    size="large"
                    block
                    icon={<SendOutlined />}
                    className="mt-6 rounded-full bg-brandBlue hover:bg-blue-600"
                    onClick={handleSendOtp}
                    loading={isSubmitting}
                >
                    {isSubmitting ? "Sending..." : "Send OTP"}
                </Button>
            </Card>
        </div>
    );
}

export default Forgot